import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import { FormattedHTMLMessage } from 'react-intl';
import Tooltip from '../Tooltip';
import Icon from '../Icon';

class LabelDescriptionIcon extends Component {
	render() {
		const { description, label, icon } = this.props;
		return (
			<div className="label-description-icon">
				{icon && <Icon icon={icon} />}
				<FormattedHTMLMessage id={label} />
				{description && <Tooltip description={description} />}
			</div>
		);
	}
}

LabelDescriptionIcon.propTypes = {
	label: PropTypes.string,
	description: PropTypes.string,
	icon: PropTypes.string
};

export default LabelDescriptionIcon;
